module.exports = __webpack_public_path__ + "static/media/didi.224d4588.wav";